<template>
  <div class="home">
    <div
      class="leftMenu"
      v-show="baseInit && systemCanUesd"
      :style="{ backgroundColor: !servicePage ? 'black' : '#015ac5' }"
    >
      <div class="logo">
        <img src="../assets/home/ic_logo_big.png" height="25px" width="25px" />
      </div>
      <div class="appBox">
        <div
          v-for="(item, index) in apps"
          :key="'apps' + index"
          style="margin-bottom: 18px"
        >
          <div
            :id="item.appName"
            class="appButtonBox"
            @click="to(item.activeRule, index)"
            v-if="servicePage || (!servicePage && item.appName == 'System')"
          >
            <!-- :class="
                currentAppName == item.appName
                  ? 'appButtonBox activeApp'
                  : 'appButtonBox'
              " -->
            <!-- :style="{background: ($actions.getGlobalState("currentAppName")==item.appName)?'##0049a0':'unset'}" -->
            <template>
              <div class="iconAndName">
                <div
                  :class="
                    currentAppName == item.appName
                      ? servicePage
                        ? 'appIcon activeApp'
                        : 'appIcon black'
                      : 'appIcon'
                  "
                >
                  <div
                    :class="
                      servicePage
                        ? 'iconBox iconBlueBox'
                        : 'iconBox iconBlackBox'
                    "
                  >
                    <img
                      :src="testBase64(item.icon) ? item.icon : defaultIcon"
                      alt=""
                      height="25px"
                      width="25px"
                      style="object-fit: contain"
                      :id="`${item.appName}.icon`"
                    />
                  </div>
                </div>
                <div class="appName">
                  <span :id="`${item.appName}.name`">{{ item.appName }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="pluginBox" v-if="!isEmpty(this.plugins) && servicePage">
        <div v-for="(item, index) in plugins" :key="index">
          <!-- <div @click="toPlugin(item)">{{item.appName}}</div> -->
          <template>
            <div class="iconAndName">
              <div
                :class="
                  currentAppName == item.appName
                    ? 'appIcon activeApp'
                    : 'appIcon'
                "
                @click="toPlugin(item)"
              >
                <div class="iconBox iconBlueBox">
                  <img
                    :src="testBase64(item.icon) ? item.icon : defaultIcon"
                    alt=""
                    height="25px"
                    width="25px"
                    style="object-fit: contain"
                    :id="`${item.appName}.icon`"
                  />
                </div>
              </div>
              <div class="appName">
                <span :id="`${item.appName.replace('Plugin@', '')}`">{{
                  item.appName.replace("Plugin@", "")
                }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="versionBox">
        <div>
          <i
            id="showMenu"
            style="color: white; cursor: pointer"
            @click="menuTreeshow()"
            :class="menuTree ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
          />
        </div>
      </div>
    </div>
    <div style="width: 60px" v-show="baseInit"></div>
    <div
      class="container"
      :style="{ width: baseInit ? 'calc(100% - 60px)' : '100%' }"
    >
      <div
        class="topHeader"
        v-show="topHeaderRender && baseInit && systemCanUesd"
      >
        <!-- <topHeader
            :externApps="externApps"
            :languageList="languageList"
            :orgDomains="orgDomains"
          ></topHeader> -->
      </div>
      <div
        class="homeContainer"
        id="home"
        :style="{ height: baseInit ? 'calc(100% - 50px)' : '100%' }"
        v-if="systemCanUesd"
      ></div>
    </div>
    <div
      class="fixedTopHeader"
      v-if="topHeaderRender && baseInit && systemCanUesd"
    >
      <topHeader
        ref="topHeader"
        :externApps="externApps"
        :languageList="languageList"
        :orgDomains="orgDomains"
        @pageChange="pageChange"
      ></topHeader>
    </div>

    <!-- 版本信息dialog -->
    <el-dialog
      :title="$t('messageBox.messageDetails')"
      :visible.sync="inboxDetailDialog.show"
      width="500"
      custom-class="messageDialogClass"
      :close-on-click-modal="false"
      @close="closeInboxDetailDialog"
      v-if="inboxDetailDialog.show"
    >
      <div class="messageBox">
        <h2 class="messageTitle">{{ getMessageDetailTitle() }}</h2>
        <!-- <el-divider></el-divider> -->
        <div class="messageContent">
          <div id="baseMessageContent"></div>
        </div>
        <el-divider></el-divider>
        <div class="messageFooter">
          <div class="adnexa" v-if="!isEmpty(messageDetails.attaches)">
            <div class="adnexaTitle">
              <div>{{ `${$t("messageBox.appendFile")}:` }}</div>
              <el-button
                type="text"
                @click="
                  downloadAppendFile(messageDetails.attaches, messageDetails.id)
                "
                >{{ $t("messageBox.downloadAll") }}</el-button
              >
            </div>

            <div
              class="appendFiles"
              v-for="(item, index) in messageDetails.attaches"
              :key="index"
              @click="downloadAppendFile([item], messageDetails.id)"
            >
              <span>{{ item.attachName }}</span>
              <i class="el-icon-download" style="color: #015ac5"></i>
            </div>
          </div>
          <el-divider v-if="!isEmpty(messageDetails.attaches)"></el-divider>
          <div class="createUser">
            {{ `${$t("messageBox.createUser")}:${messageDetails.createUser}` }}
          </div>
          <div class="createTime">
            {{
              `${$t("messageBox.createTime")}:${dataToString(
                messageDetails.createTime
              )}`
            }}
          </div>
        </div>
      </div>
      <!-- < <div slot="footer">
          <el-button @click="closeInboxDetailDialog()">取 消</el-button>
          <el-button type="primary" @click="closeInboxDetailDialog()">{{
            $t("button.confirm")
          }}</el-button>
        </div> -->
    </el-dialog>

    <!-- 上传License文件的弹窗 -->
    <el-dialog
      width="50%"
      :title="$t('license.uploadLicenseFile')"
      :visible.sync="licenseDialog.visiable"
      custom-class="dialogStyle"
      align="left"
      :modal-append-to-body="true"
      :append-to-body="false"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeLicenseDialog"
    >
      <!-- el-dialog提示用户，上传文件的提示信息,超级管理员：上传试用license,未上传license，普通用户：上传试用license,未上传license -->
      <div style="margin-bottom: 25px" v-if="isAdminCheck == true">
        <el-alert
          v-if="!licenseInfo.licenseStatus"
          :title="$t('license.timeTipProbationary')"
          type="error"
          :closable="false"
        >
        </el-alert>
        <el-alert
          v-if="licenseInfo.licenseStatus"
          :title="$t('license.timeTipOffical')"
          type="error"
          :closable="false"
        >
        </el-alert>
      </div>
      <div style="margin-bottom: 25px" v-if="isAdminCheck == false">
        <el-alert
          v-if="!licenseInfo.licenseStatus"
          :title="$t('license.timeTipnoadminProbationary')"
          type="error"
          :closable="false"
        >
        </el-alert>
        <el-alert
          v-if="licenseInfo.licenseStatus"
          :title="$t('license.timeTipnoadminOffical')"
          type="error"
          :closable="false"
        >
        </el-alert>
      </div>
      <!-- -----------------------------------------结尾: el-dialog提示用户，上传文件的提示信息--------------------------------- -->
      <div v-if="isAdminCheck">
        <el-upload
          action="fakeaction"
          :on-change="fileUploadChangeLicense"
          :on-remove="fileRemoveChange"
          :auto-upload="false"
          :file-list="uploadLicenseForm.fileList"
          :show-file-list="true"
          :limit="1"
          drag
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ $t("license.dragFile") }}
          </div>
          <div class="el-upload__text">
            {{ $t("license.fileTip") }}
          </div>
        </el-upload>
        <el-progress
          v-if="uploadLicenseForm.startUpload"
          :percentage="uploadLicenseForm.uploadPerc"
          :status="uploadLicenseForm.uploadStatus"
          :stroke-width="3"
        ></el-progress>
        <div style="white-space: nowrap; text-align: center">
          <el-checkbox
            :label="$t('license.license Privacy Agreement')"
            name="type"
            :disabled="disabledCheckBox"
            v-model="checkValue"
            :true-label="1"
            :false-label="0"
          ></el-checkbox>
          <span
            class="privacyStyle privacyStylehover"
            @click="openPrivacyAgreement"
            >{{ $t("license.Privacy Agreement") }}</span
          >
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog()">{{
          $t("button.logoutSystem")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="uploadLicenseFile()"
          :disabled="isButtonDisabled"
          >{{ $t("button.confirm") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 软件协议的弹窗 -->
    <el-dialog
      width="40%"
      :title="$t('license.privacyTitle')"
      :visible.sync="licenseDialog.innerVisible"
      custom-class="dialogStyle"
      align="left"
      :modal-append-to-body="true"
      :append-to-body="false"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="openButCancle()"
    >
      <div class="content">
        <div>&nbsp;&nbsp;&nbsp;&nbsp;{{ this.$t("license.mainPassage") }}</div>
        <div class="contentTitle">1. {{ this.$t("license.firstTitle") }}</div>
        <div>1.1 &nbsp;{{ this.$t("license.firstPassageOne") }}</div>
        <div>1.2 &nbsp;{{ this.$t("license.firstPassageTwo") }}</div>
        <div>1.3 &nbsp;{{ this.$t("license.firstPassageThree") }}</div>
        <div>1.4 &nbsp;{{ this.$t("license.firstPassageFour") }}</div>
        <div>1.5 &nbsp;{{ this.$t("license.firstPassageFive") }}</div>
        <div class="contentTitle">2. {{ this.$t("license.secondTitle") }}</div>
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;{{ this.$t("license.secondPassageOne") }}
        </div>
        <div class="contentTitle">3. {{ this.$t("license.thirdTitle") }}</div>
        <div>3.1 &nbsp;{{ this.$t("license.thirdPassageOne") }}</div>
        <div>3.2 &nbsp;{{ this.$t("license.thirdPassageTwo") }}</div>
        <div class="contentTitle">4. {{ this.$t("license.forthTitle") }}</div>
        <div>4.1 &nbsp;{{ this.$t("license.forthPassageOne") }}</div>
        <div>4.2 &nbsp;{{ this.$t("license.forthPassageTwo") }}</div>
        <div class="contentTitle">5. {{ this.$t("license.fifthTitle") }}</div>
        <div>5.1 &nbsp;{{ this.$t("license.fifthPassageOne") }}</div>
        <div>5.2 &nbsp;{{ this.$t("license.fifthPassageTwo") }}</div>
        <div>5.3 &nbsp;{{ this.$t("license.fifthPassageThree") }}</div>
        <div class="contentTitle">6. {{ this.$t("license.sixTitle") }}</div>
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;{{ this.$t("license.sixPassageOne") }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="openButCancle()">{{
          $t("button.cancel")
        }}</el-button>
        <el-button type="primary" size="small" @click="agreeLicense()">{{
          $t("button.agree")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { setDefaultMountApp, start, registerMicroApps } from "qiankun";
import topHeader from "@/components/topHeader.vue";
import {
  isEmpty,
  contains,
  getRealPath,
  indexOfContains,
  dataToString,
  dataToDay,
  testBase64,
} from "@/utils/utils.js";
import { contactSocket, webSocket, clearTimer } from "@/utils/wsUtils.js";
export default {
  components: { topHeader },
  watch: {
    "$store.state.config.dataUpdate"(newVal) {
      if (newVal == "dataUpdate") {
        console.log("重新获取workBench");
        this.getWorkBench();
        this.$store.commit("config/dataUpdate", "");
      }
    },
    "$store.state.wsStore.messageData"(newVal) {
      console.log("当前有 新消息", newVal);
      this.baseMessageHandler(newVal);
    },
    "$store.state.config.inboxDetailDialog"(newVal) {
      // 监听到数据变化，先执行请求， 后处理数据
      if (newVal.show) {
        this.getMessageDetails().then(() => {
          this.inboxDetailDialog = newVal;
          this.$nextTick(() => {
            let language = this.$i18n.locale;
            document.getElementById("baseMessageContent").innerHTML =
              this.messageDetails?.content[language]?.body ??
              this.messageDetails?.content["en"]?.body ??
              this.messageDetails?.content["default"]?.body ??
              (this.messageDetails?.content
                ? this.messageDetails?.content[
                    Object.keys(this.messageDetails.content)[0]
                  ]?.body
                : "");
          });
        });
      }
    },
    licenseInfo(newVal) {
      if (!newVal.permanentAuthorization) {
        if (Number(newVal.expirationTime) > Number(new Date().valueOf())) {
          this.systemCanUesd = true;
          this.time = Math.floor(
            (this.licenseInfo.expirationTime - new Date().valueOf()) /
              (24 * 3600 * 1000)
          );
          this.day = dataToDay(this.licenseInfo.expirationTime);
          this.resetLicenseMessage();
          this.createLicenseMessage();
          return;
        } else {
          this.systemCanUesd = false;
          this.licenseDialog.visiable = true;
        }
      } else {
        this.resetLicenseMessage();
      }
    },
    globalCurrentLanguage(newVal) {
      // 更新vue-i18n语言
      this.$i18n.locale = newVal;
      if (this.licenseInfo.expirationTime) {
        this.resetLicenseMessage();
        this.time = Math.floor(
          (this.licenseInfo.expirationTime - new Date().valueOf()) /
            (24 * 3600 * 1000)
        );
        this.day = dataToDay(this.licenseInfo.expirationTime);
        this.$nextTick(() => {
          this.createLicenseMessage();
        });
      }
    },
    licenseUpdate(newVal) {
      if (newVal) {
        this.getAndSetLicenseInfo(false);
        this.$actions.setGlobalState({
          licenseUpdate: false,
        });
      }
    },
  },
  computed: {
    languageList() {
      // const isProduction = process.env.NODE_ENV === "production";
      // const isProduction = true;
      if (this.$isProduction) {
        console.log(this.$store.state.config.languageList);
        return this.$store.state.config.languageList;
      }
      return window.HS_CONFIG.languageList;
    },
    currentAppName() {
      return this.$actions.getGlobalState("currentAppName");
    },
    hiddenTopHeaderPages() {
      return window.HS_CONFIG.hiddenTopHeaderPages;
    },
    pluginsConfig() {
      return window.HS_CONFIG.basePluginsConfig;
    },
    servicePage() {
      return this.$actions.getGlobalState("servicePage");
    },
    // inboxDetailDialog() {
    //   return this.$store.state.config.inboxDetailDialog;
    // },
    isButtonDisabled() {
      if (this.uploadLicenseForm.disabledUpload || this.checkValue == 0) {
        return true;
      } else {
        return false;
      }
    },
    globalCurrentLanguage() {
      return this.$actions.getGlobalState("currentLanguage");
    },

    noShowTips() {
      return this.$store.state.config.noShowTips;
    },
    licenseUpdate() {
      return this.$actions.getGlobalState("licenseUpdate");
    },
  },

  data() {
    return {
      defaultIcon: require("@/assets/application.png"),
      menuTree: "true",
      apps: [],
      plugins: [],
      currentApp: {},
      topHeaderRender: false,
      licenseInfo: {},
      appsVersion: "",
      dialogStatu: {
        version: false,
      },
      externApps: [],
      orgDomains: [],

      baseInit: true,
      timer: "",

      // 消息详情信息
      messageDetails: {},

      inboxDetailDialog: {},

      // 上传license文件的弹窗以及协议的弹窗
      licenseDialog: {
        visiable: false,
        innerVisible: false,
      },
      // 上传license 表单
      uploadLicenseForm: {
        licFile: "",
        fileList: [],
        disabledUpload: true,
        startUpload: "",
        uploadPerc: "",
        uploadStatus: null,
      },
      dataToString,
      isAdminCheck: "",
      disabledCheckBox: true, // 同意协议是否可以点击
      checkValue: "", // 是否同意协议,
      systemCanUesd: true,
      licenseMessageTip: null, // license message instance
      useResetMessage: false,
    };
  },
  created() {
    ///////////////////// 调用请求 /v2/license  get///////////////////////
    let promiseList = [];
    promiseList.push(this.getWorkBench());
    if (isEmpty(this.languageList)) {
      promiseList.push(this.getLanguageList());
    }
    Promise.all(promiseList)
      .then(() => {
        contactSocket();
        this.timer = window.setInterval(() => {
          if (document.readyState === "complete") {
            this.toApp();
            let currentAppName = this.$actions.getGlobalState("currentAppName");
            // console.log(this.apps);
            try {
              if (!isEmpty(this.apps)) {
                setDefaultMountApp(
                  this.apps.find((item) => item.appName == currentAppName)
                    .activeRule[0]
                );
              }
            } catch (error) {
              //当有异常  直接默认跳转到第一个应用
              // console.log("当前出现异常");
              // console.log(error);
              if (!isEmpty(this.apps)) {
                setDefaultMountApp(this.apps[0].activeRule[0]);
              }
            }
            window.clearInterval(this.timer);
          }
        }, 800);
      })
      .finally(() => {
        this.getLicenseInfo();
      });
    // 防止在全屏页面刷新
    let url = window.location.href;
    let hashIndex = url.indexOf("#");
    let router = url.substring(hashIndex);
    if (this.hiddenTopHeaderPages.some((item) => contains(router, item))) {
      this.baseInit = false;
    } else {
      this.baseInit = true;
    }
  },
  mounted() {
    window.addEventListener("popstate", () => {
      // vue router 内部走的history pushState     hashChange监听不到， so  监听popstate
      // console.log("popState, 监听到url 变化");
      let url = window.location.href;
      let hashIndex = url.indexOf("#");
      let router = url.substring(hashIndex);
      if (this.hiddenTopHeaderPages.some((item) => contains(router, item))) {
        this.baseInit = false;
      } else {
        this.baseInit = true;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("popstate", () => {
      console.log("移除popstate 监听事件");
    });
    if (this.timer) {
      window.clearInterval(this.timer);
    }
    // 移除ws
    if (!isEmpty(webSocket)) {
      try {
        webSocket.close();
        webSocket = {};
      } catch (err) {
        // 这里会报错, 仅在开发环境热更新时会报错 ，完全不需要处理 ，看着烦就不打印了
        // console.log(err);
      } finally {
        clearTimer();
      }
    }
  },
  methods: {
    testBase64,
    isEmpty,
    getVersion() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getAppVersion()
          .then((res) => {
            if (res.resultCode == 1001) {
              this.appsVersion = res.data ?? "";
              let data = res.data ?? "";
              if (!isEmpty(data)) {
                Object.keys(data).forEach((item) => {
                  if (item == "All-Star") {
                    let value = data[item];
                    data.System = value;
                    delete data[item];
                  }
                });
              }
              this.appsVersion = data;
            }
            this.dialogStatu.version = true;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 重置 License 提示信息
    resetLicenseMessage() {
      if (this.licenseMessageTip) {
        this.useResetMessage = true;
        this.licenseMessageTip.close();
        this.licenseMessageTip = null;
      }
    },
    // 创建 License 提示信息
    createLicenseMessage() {
      if (!this.licenseMessageTip && !this.noShowTips) {
        const h = this.$createElement;
        this.licenseMessageTip = this.$message({
          showClose: true,
          message: h(
            "div",
            {
              style: {
                "min-width": "55vw",
                "max-width": "80vw",
                "box-sizing": "border-box",
                padding: "0 20px 0 10px",
              },
            },
            [
              h(
                "div",
                {
                  style: {
                    "word-break": "break-all",
                    color: "white",
                  },
                },
                this.isAdminCheck
                  ? this.licenseInfo.licenseStatus
                    ? `${this.$t("license.time90Tip", {
                        day: `${this.day}`,
                        time: `${this.time}`,
                      })}`
                    : `${this.$t("license.time30Tip", {
                        day: `${this.day}`,
                        time: `${this.time}`,
                      })}`
                  : this.licenseInfo.licenseStatus
                  ? `${this.$t("license.notAdmintime90Tip", {
                      day: `${this.day}`,
                      time: `${this.time}`,
                    })}`
                  : `${this.$t("license.notAdmintime30Tip", {
                      day: `${this.day}`,
                      time: `${this.time}`,
                    })}`
              ),
            ]
          ),
          duration: 0,
          customClass: "messageTipStyle",
          offset: 1,
          onClose: () => {
            if (this.useResetMessage) {
              this.useResetMessage = false;
            } else {
              this.notShowTip();
            }
          },
        });
      }
    },
    // License 手动关闭
    notShowTip() {
      if (!this.noShowTips) {
        this.$store.commit("config/changeTipsStatus", true);
      }
    },

    getWorkBench() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getWorkBench()
          .then((res) => {
            //TODO 有点复杂 后续优化
            let data = res.data;
            if (data.permissionTree) {
              Object.keys(data.permissionTree).forEach((item) => {
                let permissions = data.permissionTree[item];
                if (permissions && permissions.length > 0) {
                  this.hasChild(permissions);
                }
              });
            }
            this.$actions.setGlobalState({
              commonData: {
                customer: data.customers, // 该用户下所有客户
                username: data.username,
                userId: data.userId,
                data: data.data,
              },
              currentUser: data.user,
              permissionTree: data.permissionTree,
            });
            if (!isEmpty(data.user)) {
              if (data.user.domains == "**") {
                this.isAdminCheck = true;
              }
            } else {
              this.isAdminCheck = false;
            }
            //  语言偏好设置
            if (!this.$actions.getGlobalState("loginFlag")) {
              if (data?.user?.languagePreference) {
                let language = data.user.languagePreference;
                // 如果当前支持的语言列表不存在该语言 ,默认切换为英文
                // console.log(this.$store.state.config.languageList);
                let languageList = [];
                this.$isProduction
                  ? (languageList = this.$store.state.config.languageList)
                  : (languageList = window.HS_CONFIG.languageList);
                if (
                  isEmpty(languageList.find((item) => item.code == language))
                ) {
                  language = "en";
                }
                this.$nextTick(() => {
                  this.$actions.setGlobalState({
                    currentLanguage: language,
                  });
                });
              }
            }
            this.$actions.setGlobalState({ loginFlag: true });

            // 浅浅异步解析一下 permissionTree 看是否有system view 和 global view权限
            window.setTimeout(() => {
              if (
                !isEmpty(data.permissionTree) &&
                !isEmpty(data.permissionTree["All-Star"])
              ) {
                // 认为当前有as 的权限   ， 可以进入密码修改页面和 用户信息页面
                this.$store.commit("config/hasAsPermission", true);

                //  是否有 管理权限
                let manageFlag = data.permissionTree["All-Star"].some((item) =>
                  ["SYSTEM", "GLOBAL"].includes(item.realm)
                );
                // 是否有 业务权限
                let serviceFlag = data.permissionTree["All-Star"].some((item) =>
                  ["ADMIN", "OPERATOR"].includes(item.realm)
                );
                if (manageFlag && serviceFlag) {
                  this.$store.commit("config/hasServicePage", true);
                  // if(res.data.user.domains == '**'){
                  //   this.$actions.setGlobalState({servicePage:false})
                  // }
                } else {
                  if (manageFlag)
                    this.$actions.setGlobalState({ servicePage: false });
                  if (serviceFlag)
                    this.$actions.setGlobalState({ servicePage: true });
                }
              }
            });

            if (isEmpty(data.apps)) {
              reject();
              this.topHeaderRender = true;
              this.$confirm(this.$t("loginPromptMessage.noPermission"), "", {
                confirmButtonText: this.$t("button.exitImmediately"),
                type: "warning",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
                showCancelButton: false,
              }).then(() => {
                this.$actions.setGlobalState({ logout: true });
              });
              return;
            }
            if (isEmpty(data.user.domains)) {
              reject();
              this.topHeaderRender = true;
              this.$confirm(this.$t("loginPromptMessage.noCustomer"), "", {
                confirmButtonText: this.$t("button.exitImmediately"),
                type: "warning",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
                showCancelButton: false,
              }).then(() => {
                this.$actions.setGlobalState({ logout: true });
              });
              return;
            }

            let externApps = [];
            data.apps.forEach((item) => {
              if (!isEmpty(item.appType) && item.appType == "Template") {
                externApps.push(item);
              }
            });
            this.externApps = externApps;
            let apps = data.apps.filter(
              (item) =>
                !isEmpty(item.activeRule) &&
                !isEmpty(item.appType) &&
                !isEmpty(item.entry) &&
                item.appType == "Internal"
            );
            if (isEmpty(apps)) {
              // apps 仅包含PDA handyLink，template 等 无页面权限的应用时
              this.topHeaderRender = true;
              resolve();
              return;
            }
            // TODO 后续增加友好处理 无权限情况
            apps.forEach((item) => {
              if (item.webRoot.toLowerCase() == "allstar") {
                item.appName = "System";
              }
              item.name = item.webRoot;
              item.props = {};
              item.props.getGlobalState = this.$actions.getGlobalState;
              item.props.gateway = "/proxy/" + item.webRoot;
              item.container = "#home";
            });
            this.apps = apps;

            let as = apps.find(
              (item) => item.webRoot.toLowerCase() == "allstar"
            );
            // 公共区域为空   执行默认选择， 默认选择规则，有as进as 没有默认进第一个
            if (isEmpty(this.$actions.getGlobalState("currentAppName"))) {
              //看 as情况， 有as 进as ，没有默认进第一个应用
              if (isEmpty(as)) {
                this.$actions.setGlobalState({
                  currentAppName: apps[0]?.appName,
                });
              } else {
                this.$actions.setGlobalState({
                  currentAppName: as.appName,
                });
              }
            }
            // 当前确保公共区域里面有数据
            this.getAdministrator(data.user.domains);
            if (document.getElementById("home")) {
              registerMicroApps(apps, {
                beforeLoad: (app) => console.log("before load", app.name),
                beforeMount: (app) => console.log("before mount", app.name),
                beforeUnmount: (app) => console.log("unmount", app.name),
              });
              this.topHeaderRender = true;
            }

            resolve(data.permissionTree);
          })
          .catch((err) => {
            reject(err);
          });
      }).then((data) => {
        this.getInsertBasePlugins(data);
      });
    },

    getInsertBasePlugins(permissions) {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getRunningPluginInfo()
          .then((res) => {
            if (res.resultCode == 1001) {
              // 区分是开发环境还是线上环境， 开发环境用我们自己配置的   方便开发 ， 线上环境自动生成
              const isProduction = process.env.NODE_ENV === "production";
              let plugins = res.data.filter(
                (item) =>
                  item?.status?.toLowerCase() == "installed" &&
                  item.mode &&
                  item.mode == "Portal"
              );
              // console.log(plugins);
              // 如果当前安装在Portal上的插件为空，直接停止使用
              if (isEmpty(plugins)) {
                return;
              }
              // 获取 All-Star 权限， 如果allStar 权限为空， 后续都不需要执行
              // console.log(this.$actions.getGlobalState("permissionTree"));
              // console.log(
              //   this.$actions.getGlobalState("permissionTree")["All-Star"]
              // );
              let allStarPermissions = permissions
                ? permissions["All-Star"]
                : null;
              // console.log(allStarPermissions);
              if (isEmpty(allStarPermissions)) {
                this.plugins = [];
                resolve(res);
                return;
              }
              let pluginPermissions = allStarPermissions.filter((item) =>
                contains(item.permsCode, "Plugins@")
              );
              // console.log(pluginPermissions);
              let pluginPermissionPluginIds = pluginPermissions.map((item) =>
                this.getPluginIdFromPermission(item.permsCode)
              );

              // 区分是开发环境还是线上环境
              if (isProduction) {
                plugins = plugins.map((item) => {
                  return {
                    appName: "Plugin@" + item.pluginId,
                    name: "Plugin@" + item.pluginId,
                    props: {
                      getGlobalState: this.$actions.getGlobalState,
                      baseRouter: `/${item.pluginId}`,
                      permissions: pluginPermissions.filter((pers) =>
                        indexOfContains(
                          pers.permsCode,
                          `Plugins@${item.pluginId}@`
                        )
                      ),
                    },
                    container: "#home",
                    entry: `${getRealPath()}/static-plugin/${
                      item.pluginId
                    }/static`,
                    activeRule: "#/" + item.pluginId,
                    icon: pluginPermissions.find((pers) =>
                      indexOfContains(
                        pers.permsCode,
                        `Plugins@${item.pluginId}@`
                      )
                    )?.icon,
                    // icon:pluginPermissions.find(item=>contains(item.permsCode,`Plugins@${item.pluginId}`))?.icon
                  };
                });
              } else {
                let installPluginIds = plugins.map((item) => item.pluginId);
                // console.log(installPluginIds);
                let data = this.pluginsConfig.filter((item) =>
                  installPluginIds.includes(item.name.replace("Plugin@", ""))
                );
                data.forEach((item) => {
                  item.appName = item.name;
                  item.container = "#home";
                  item.props = {};
                  item.props.getGlobalState = this.$actions.getGlobalState;
                  item.props.baseRouter = item.activeRule[0].replace("#", "");
                  item.props.permissions = pluginPermissions.filter((pers) =>
                    indexOfContains(
                      pers.permsCode,
                      item.name.replace("Plugin@", "Plugins@")
                    )
                  );
                  item.icon = pluginPermissions.find((pers) =>
                    contains(
                      pers.permsCode,
                      item.name.replace("Plugin@", "Plugins@")
                    )
                  )?.icon;
                });
                plugins = data;
              }

              // console.log("当前插入base 的 插件", plugins);
              // 当前获取到了插件的信息  还需要增加权限的限制

              // 插件前端页面显示
              // this.plugins=plugins

              // console.log(plugins);
              this.plugins = plugins.filter((item) =>
                pluginPermissionPluginIds.includes(
                  item.appName.replace("Plugin@", "")
                )
              );
              // console.log(plugins);

              //  插件权限问题 处理
              if (!isEmpty(plugins)) {
                registerMicroApps(plugins, {
                  beforeLoad: (app) =>
                    console.log("before plugin load", app.name),
                  beforeMount: (app) =>
                    console.log("before plugin mount", app.name),
                  beforeUnmount: (app) =>
                    console.log("unmount plugin", app.name),
                });
              }
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getLanguageList() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getConfigByName("systemI18n")
          .then((res) => {
            if (res.resultCode == 1001) {
              // console.log(res.data);
              if (!isEmpty(res.data)) {
                this.$store.commit("config/initLanguageList", res.data.value);
              }
              resolve(res);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 权限树无用数据清空
    hasChild(data) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          delete item.link;
          delete item.appId;
          delete item.createTime;
          delete item.extend;
          delete item.updateTime;
          if (item.childNodes && item.childNodes.length > 0) {
            this.hasChild(item.childNodes);
          }
        });
      }
    },
    toApp() {
      if (!document.getElementById("home")) {
        return;
      }
      try {
        start({
          singular: false,
          prefetch: "all",
          sandbox: { experimentalStyleIsolation: true },
          fetch(url, ...args) {
            return window.fetch(url, {
              ...args,
              mode: "cors",
              // credentials: "include"
            });
          },
        });
      } catch (error) {
        //  会出现加载出现问题 ，如若currAppName 有值， 进currentAppName 如果没有，进第一个应用
        let currentAppName = this.$actions.getGlobalState("currentAppName");
        let currentApp = {};
        if (!isEmpty(currentAppName)) {
          currentApp = this.apps.find(
            (item) => item.appName.toLowerCase() == currentAppName.toLowerCase()
          );
        } else {
          currentApp = this.apps[0];
        }
        if (!isEmpty(currentApp)) {
          history.pushState(null, null, currentApp.activeRule[0]);
        } else {
          console.error("当前未接入应用");
        }
      }
    },
    toPlugin(data) {
      // console.log(data);
      history.pushState(null, null, data.activeRule);
      history.forward();
      this.$actions.setGlobalState({
        currentAppName: data.appName,
      });
    },
    menuTreeshow() {
      this.menuTree = !this.menuTree;
      this.$actions.setGlobalState({
        showMenu: this.menuTree,
      });
    },
    to(data, index) {
      //TODO 需要等待上个应用完全卸载完成再跳转 ， 就可避免 快速切换渲染问题
      this.$nextTick(() => {
        // console.log(data);
        if (typeof data == "string") {
          history.pushState(null, null, data);
        } else if (data.length > 0) {
          history.pushState(null, null, data[0]);
        }
        history.forward();
        // 记录当前应用
        this.$actions.setGlobalState({
          currentAppName: this.apps[index].appName,
        });
      });
    },

    openWindow(entry) {
      let url = entry;
      let accessToken = this.$actions.getGlobalState("accessToken");
      //加密
      // let nnnnn=aes.encrypt(accessToken);
      url += "?token=" + accessToken;
      window.open(url);
    },
    getAdministrator(domains) {
      if (domains == "**") {
        this.orgDomains = ["**"];
      } else {
        let domain = domains.split(",");
        let orgDomains = domain.filter((item) => item.indexOf("**") != -1);
        this.orgDomains = orgDomains;
      }
    },
    getPluginIdFromPermission(data) {
      let index = data.indexOf("@") + 1;
      let lastIndex = data.lastIndexOf("@");
      return data.substring(index, lastIndex);
    },

    toByAppObj(data) {
      if (!isEmpty(data) && !isEmpty(data.activeRule) && data.appName) {
        history.pushState(null, null, data.activeRule[0]);
        history.forward();
        this.$actions.setGlobalState({
          currentAppName: data.appName,
        });
      }
    },
    pageChange(data) {
      if (data == "exit") {
        // 退出时 先关闭 ws
        if (!isEmpty(webSocket)) {
          try {
            webSocket.close();
            webSocket = {};
          } catch (err) {
            // 这里会报错, 仅在开发环境热更新时会报错 ，完全不需要处理 ，看着烦就不打印了
            // console.log(err);
          } finally {
            clearTimer();
          }
        }
        this.$actions.setGlobalState({
          logout: true,
        });
      } else {
        // 其他操作 需要先跳转至allstar
        if (this.currentAppName == "System") {
          this.resolvePageChange(data);
        } else {
          let as = this.apps.find(
            (item) => item?.appName && item.appName == "System"
          );
          if (!isEmpty(as)) {
            // 跳转至allstar
            this.resolvePageChange(data);
            this.toByAppObj(as);
          }
        }
      }
    },
    resolvePageChange(data) {
      switch (data) {
        case "userInfo":
          this.$actions.setGlobalState({ asFirstInPage: "userInfo" });
          break;
        case "passwordChange":
          this.$actions.setGlobalState({ asFirstInPage: "pwdChange" });
          break;
        case "versionInfo":
          this.$actions.setGlobalState({ asFirstInPage: "versionInfo" });
          break;
        case "pageChange":
          this.$actions.setGlobalState({
            servicePage: !this.$actions.getGlobalState("servicePage"),
          });
          break;
        case "messageCenter":
          this.$actions.setGlobalState({
            messageCenter: true,
          });
          break;
        default:
          console.log("其他操作", data);
      }
    },
    closeInboxDetailDialog() {
      document.getElementById("baseMessageContent").innerHTML = "";
      this.messageDetails = {};
      this.$store.commit("config/changeInboxDetailDialog", {
        show: false,
        id: "",
      });
    },
    //  获取消息详情
    getMessageDetails() {
      // console.log(this.inboxDetailDialog);
      return new Promise((resolve, reject) => {
        this.$httpList
          .getMessageDetails(this.$store.state.config.inboxDetailDialog.id, {
            language: this.$i18n.locale,
          })
          .then((res) => {
            if (res.resultCode == 1001) {
              // console.log(res);
              this.messageDetails = res.data;
              if (this.$refs.topHeader?.$refs?.messageTable) {
                this.$refs.topHeader.$refs.messageTable.updateTableData();
              }
              resolve(res);
            }
          })
          .catch((err) => reject(err));
      });
    },

    // 通知消息处理
    baseMessageHandler(data) {
      if (
        ["NORMAL_NOTICE", "IMPORTANT_NOTICE", "WARNING_NOTICE"].includes(
          data.type
        )
      ) {
        this.createMessageVirtualNode(data);
      }
      if (data.type == "LOGOUT_BY_PLUGIN_REMOVE") {
        this.$confirm(
          this.$t("logoutBoxPromptMessage.logoutByPluginRemove", {
            pluginId: data.pluginId,
          }),
          "",
          {
            confirmButtonText: this.$t("button.exitImmediately"),
            cancelButtonText: this.$t("button.exitLater"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
        )
          .then(() => {
            // console.log("执行立即退出");
            window.setTimeout(() => {
              this.$actions.setGlobalState({ logout: true });
            }, 0);
          })
          .catch(() => {
            console.log("执行稍后退出");
          });
      }
      if (data.type == "LOGOUT_BY_REMOTE_LOGIN") {
        // 退出延迟
        // let second=5;
        this.$confirm(
          this.$t("logoutBoxPromptMessage.logoutByRemoteLogin"),
          "",
          {
            showCancelButton: false,
            confirmButtonText: this.$t("button.confirm"),
            // showConfirmButton:false,
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
        ).then(() => {
          this.$actions.setGlobalState({ logout: true });
        });
      }
      if (data.type == "REFRESH_BY_PLUGIN_UNINSTALL") {
        this.$confirm(
          this.$t("logoutBoxPromptMessage.refreshByPluginUninstall", {
            pluginId: data.pluginId,
          }),
          "",
          {
            showCancelButton: false,
            confirmButtonText: this.$t("button.refreshImmediately"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
        ).then(() => {
          this.$router.push({ name: "welcome" });
          location.reload();
        });
      }
      if (data.type == "REFRESH_BY_ROLE_PERMISSION_CHANGE") {
        this.$confirm(
          this.$t("logoutBoxPromptMessage.refreshByRolePermissionChange", {
            pluginId: data.pluginId,
          }),
          "",
          {
            showCancelButton: false,
            confirmButtonText: this.$t("button.refreshImmediately"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
        ).then(() => {
          this.$router.push({ name: "welcome" });
          location.reload();
        });
      }
      if (data.type == "REFRESH_BY_USER_ROLE_CHANGE") {
        this.$confirm(
          this.$t("logoutBoxPromptMessage.refreshByUserRoleChange", {
            pluginId: data.pluginId,
          }),
          "",
          {
            showCancelButton: false,
            confirmButtonText: this.$t("button.refreshImmediately"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
        ).then(() => {
          this.$router.push({ name: "welcome" });
          location.reload();
        });
      }
      if (data.type == "LOGOUT_BY_PLUGIN_INSTALL") {
        this.$confirm(
          this.$t("logoutBoxPromptMessage.logoutByPluginInstall", {
            pluginId: data.pluginId,
          }),
          "",
          {
            confirmButtonText: this.$t("button.exitImmediately"),
            cancelButtonText: this.$t("button.exitLater"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
        )
          .then(() => {
            // console.log("执行立即退出");
            window.setTimeout(() => {
              this.$actions.setGlobalState({ logout: true });
            }, 0);
          })
          .catch(() => {
            console.log("执行稍后退出");
          });
      }
      if (data.type == "LOGOUT_BY_APP_REGISTER") {
        this.$confirm(
          this.$t("logoutBoxPromptMessage.logoutByAppPermissionRegister", {
            pluginId: data.pluginId,
          }),
          "",
          {
            confirmButtonText: this.$t("button.exitImmediately"),
            cancelButtonText: this.$t("button.exitLater"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }
        )
          .then(() => {
            // console.log("执行立即退出");
            window.setTimeout(() => {
              this.$actions.setGlobalState({ logout: true });
            }, 0);
          })
          .catch(() => {
            console.log("执行稍后退出");
          });
      }
    },
    downloadAppendFile(attachs, messageDetailsId) {
      if (!isEmpty(attachs) && !isEmpty(messageDetailsId)) {
        let attachIds = attachs.map((item) => item.attachId).join();
        this.$httpList.getAttach(messageDetailsId, { attachIds: attachIds });
      }
    },
    getMessageDetailTitle() {
      return (
        this?.messageDetails?.content[this.$i18n.locale]?.title ??
        this?.messageDetails?.content["en"]?.title ??
        this?.messageDetails?.content["default"]?.title ??
        (this?.messageDetails?.content
          ? this?.messageDetails?.content[
              Object.keys(this.messageDetails.content)[0]
            ]?.title
          : "")
      );
    },
    createMessageVirtualNode(data) {
      const h = this.$createElement;
      const that = this;
      let classMap = {
        NORMAL_NOTICE: {
          customClass: "normalNoticeBox",
          "background-color": "#015AC5",
          iconClass: "el-icon-info",
        },
        IMPORTANT_NOTICE: {
          customClass: "importantNoticeBox",
          "background-color": "#af231d",
          iconClass: "el-icon-info",
        },
        WARNING_NOTICE: {
          customClass: "warnNoticeBox",
          "background-color": "#b4c519",
          iconClass: "el-icon-info",
        },
      };
      let ignoreCloseType = ["IMPORTANT_NOTICE", "WARNING_NOTICE"];
      if (ignoreCloseType.includes(data.type)) {
        let noticeInstance = this.$message({
          iconClass: classMap[data.type].iconClass,
          offset: 2.3,
          duration: 0,
          showClose: true,
          customClass: classMap[data.type].customClass,
          message: h(
            "div",
            {
              style: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",
                "min-width": "55vw",
                "max-width": "80vw",
              },
            },
            [
              h(
                "div",
                {
                  style: {
                    "word-break": "break-all",
                    color: "white",
                    "padding-right": "17px",
                    "margin-left": "10px",
                  },
                },
                that.getElMessageData(data.data)
              ),
              h(
                "el-button",
                {
                  class: "el-button--small  messageButtonStyle",
                  style: {
                    "border-radius": "8px",
                    "background-color": classMap[data.type]["background-color"],
                    border: "1px solid white",
                    color: "white",
                    "margin-right": "25px",
                    ".el-button:active": {
                      "border-color": "white !important",
                    },
                  },
                  on: {
                    click: () => {
                      let inboxDetailDialog =
                        that.$store.state.config.inboxDetailDialog;
                      if (
                        !isEmpty(inboxDetailDialog) &&
                        inboxDetailDialog.show == false
                      ) {
                        that.$store.commit("config/changeInboxDetailDialog", {
                          show: true,
                          id: `${data.noticeId}@${data.taskId}`,
                        });
                        noticeInstance.close();
                      } else {
                        // 表明当前有正在阅读的消息    ，不可打开
                        that.$notify.warning(
                          that.$t("messageBoxPromptMessage.inReading")
                        );
                      }
                    },
                  },
                },
                that.$t("messageBox.getDetails")
              ),
            ]
          ),
        });
      } else {
        let noticeAutoCloseInstance = this.$message({
          iconClass: classMap[data.type].iconClass,
          offset: 2.3,
          duration: 5000,
          showClose: true,
          customClass: classMap[data.type].customClass,
          message: h(
            "div",
            {
              style: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",
                "min-width": "55vw",
                "max-width": "80vw",
              },
            },
            [
              h(
                "div",
                {
                  style: {
                    "word-break": "break-all",
                    color: "white",
                    "padding-right": "17px",
                    "margin-left": "10px",
                  },
                },
                that.getElMessageData(data.data)
              ),
              h(
                "el-button",
                {
                  class: "el-button--small  messageButtonStyle",
                  style: {
                    "border-radius": "8px",
                    "background-color": classMap[data.type]["background-color"],
                    border: "1px solid white",
                    color: "white",
                    "margin-right": "25px",
                    ".el-button:active": {
                      "border-color": "white !important",
                    },
                  },
                  on: {
                    click: () => {
                      let inboxDetailDialog =
                        that.$store.state.config.inboxDetailDialog;
                      if (
                        !isEmpty(inboxDetailDialog) &&
                        inboxDetailDialog.show == false
                      ) {
                        that.$store.commit("config/changeInboxDetailDialog", {
                          show: true,
                          id: `${data.noticeId}@${data.taskId}`,
                        });
                        noticeAutoCloseInstance.close();
                      } else {
                        // 表明当前有正在阅读的消息    ，不可打开
                        that.$notify.warning(
                          that.$t("messageBoxPromptMessage.inReading")
                        );
                      }
                    },
                  },
                },
                that.$t("messageBox.getDetails")
              ),
            ]
          ),
        });
      }
    },
    // 关闭弹窗时调用的函数
    closeLicenseDialog() {
      this.checkValue = 0;
      this.licenseDialog.visiable = false;
      this.uploadLicenseForm.startUpload = false;
      this.uploadLicenseForm.uploadPerc = 0;
      this.uploadLicenseForm.uploadStatus = null;
      this.uploadLicenseForm.licFile = "";
      this.uploadLicenseForm.fileList = [];
      this.uploadLicenseForm.disabledUpload = true;
    },
    // 外层嵌套关闭弹窗
    closeDialog() {
      window.setTimeout(() => {
        this.$actions.setGlobalState({ logout: true });
      }, 0);
    },
    // 打开协议弹窗
    openPrivacyAgreement() {
      this.licenseDialog.innerVisible = true;
    },
    // 打开协议弹窗但是取消了
    openButCancle() {
      this.licenseDialog.innerVisible = false;
      this.disabledCheckBox = false;
    },
    // 打开协议弹窗并且同意了
    agreeLicense() {
      this.licenseDialog.innerVisible = false;
      this.disabledCheckBox = false;
      this.checkValue = 1;
    },
    // 文件上传改变license
    fileUploadChangeLicense(licFile) {
      // 判断文件后缀
      let fileName = licFile.name;
      let fileType = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileType == "lic") {
        this.uploadLicenseForm.licFile = licFile.raw;
        if (this.uploadLicenseForm.licFile != "") {
          this.uploadLicenseForm.disabledUpload = false;
        }
      } else {
        this.uploadLicenseForm.disabledUpload = true;
      }
    },
    // 文件移除改变的时候
    fileRemoveChange() {
      this.uploadLicenseForm.licFile = "";
      if (this.uploadLicenseForm.licFile == "") {
        this.uploadLicenseForm.disabledUpload = true;
      }
      this.uploadLicenseForm.startUpload = false;
      this.uploadLicenseForm.uploadPerc = 0;
      this.uploadLicenseForm.uploadStatus = null;
    },
    getLicenseInfo() {
      // license处理
      this.$httpList.isHaveLicense().then((res) => {
        if (res.resultCode == 1001) {
          res.data.expirationTime =
            new Date(
              dataToDay(res.data.expirationTime) + " 00:00:00"
            ).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          this.licenseInfo = res.data;
          this.time = Math.floor(
            (this.licenseInfo.expirationTime - new Date().valueOf()) /
              (24 * 3600 * 1000)
          );
          this.day = dataToDay(this.licenseInfo.expirationTime);
        }
      });
    },
    //////////获取并设置license的信息///////
    getAndSetLicenseInfo(reload) {
      return new Promise(() => {
        this.$httpList.isHaveLicense().then((res) => {
          if (res.resultCode == "1001") {
            res.data.expirationTime =
              new Date(
                dataToDay(res.data.expirationTime) + " 00:00:00"
              ).getTime() +
              24 * 60 * 60 * 1000 -
              1;
            // noShowTips = false license上传成功后调用获取license信息接口  允许重新弹出到期提示
            if (
              !res.data.permanentAuthorization &&
              new Date().getTime() < res.data.expirationTime
            ) {
              this.$store.commit("config/changeTipsStatus", false);
            }
            this.licenseInfo = res.data;
            if (reload) {
              location.reload();
            }
          }
        });
      });
    },
    // 上传license文件确定按钮
    uploadLicenseFile() {
      //上传文件
      this.uploadLicenseForm.disabledUpload = true;
      let uploadInterval;
      let progressInterval;
      this.uploadLicenseForm.uploadPerc = 10;
      let formData = new FormData();
      formData.append("file", this.uploadLicenseForm.licFile);
      this.uploadLicenseForm.startUpload = true;
      return new Promise((resolve, reject) => {
        this.$httpList
          .getActionId(formData)
          .then((res) => {
            if (res.resultCode == "1001") {
              progressInterval = window.setInterval(() => {
                if (this.uploadLicenseForm.uploadPerc < 90) {
                  this.uploadLicenseForm.uploadPerc =
                    this.uploadLicenseForm.uploadPerc + 10;
                }
              }, 300);
              uploadInterval = window.setInterval(() => {
                this.$httpList.uploadLicense(res.data).then((response) => {
                  if (response.resultCode == 1001) {
                    if (response.data.status == "UPLOADED") {
                      window.clearInterval(uploadInterval);
                      window.clearInterval(progressInterval);
                      this.uploadLicenseForm.uploadPerc = 100;
                      this.uploadLicenseForm.uploadStatus = "success";
                      this.$notify.success({
                        message: this.$t("license.uploadLicenseSuccess"),
                      });
                      this.licenseDialog.visiable = false;
                      this.$actions.setGlobalState({
                        licenseUpdate: true,
                      });
                      this.getAndSetLicenseInfo(true);
                    } else if (response.data.status == "UPLOAD_FAILED") {
                      window.clearInterval(uploadInterval);
                      window.clearInterval(progressInterval);
                      this.uploadLicenseForm.uploadPerc = 90;
                      this.uploadLicenseForm.uploadStatus = "exception";
                      if (response.data.errMessage) {
                        this.$notify.error({
                          message: this.$t(
                            "httpResponsePromptMessage." +
                              response.data.errMessage.split(":")[0]
                          ),
                        });
                      } else {
                        this.$notify.error({
                          message: this.$t("httpResponsePromptMessage.A0803"),
                        });
                      }
                    }
                  }
                });
              }, 1000);
            }
            resolve(res);
          })
          .catch((err) => {
            window.clearInterval(uploadInterval);
            window.clearInterval(progressInterval);
            this.uploadLicenseForm.uploadStatus = "exception";
            reject(err);
          });
      });
    },

    // 普通重要警告通知，根据数据类型返回显示内容
    getElMessageData(data) {
      if (typeof data == "object") {
        return data[this.$i18n.locale] ?? data["default"] ?? data["en"];
      }
      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
.messageBox {
  .messageTitle {
    font-size: 18px;
    font-weight: 700px;
    // color: #393a3a;
    color: gray;
  }
  .adnexa {
    margin: 10px 0;
    .adnexaTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .appendFiles {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 2px 5px;
      cursor: pointer;
    }
    .appendFiles:hover {
      background-color: #ecf5ff;
    }
  }
  .messageContent {
    overflow: auto;
  }
}
::v-deep .messageDialogClass {
  border-radius: 8px;
  .el-dialog__body {
    padding: 0px 20px 30px 20px;
  }
}
.black {
  background: black !important;
}
.activeApp {
  background: #00489e;
}
.home {
  width: 100%;
  height: 100%;
  display: flex;
  .container {
    height: 100%;
    // width: calc(100% - 60px);
    display: flex;
    flex-direction: column;
    .topHeader {
      height: 50px;
    }
    .homeContainer {
      height: calc(100% - 50px);
    }
  }
  .leftMenu {
    height: 100vh;
    width: 60px;
    background: #015ac5;
    position: fixed;
    .logo {
      //   position: relative;
      width: 60px;
      height: 42px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
    .appBox {
      // height: calc(100% - 42px - 38px);
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: flex-start;
      padding-top: 20px;
      align-items: center;
      .appButtonBox {
        border-radius: 8px;
        height: 60px;
        width: 40px;
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-weight: 700;
        color: white;
        .iconAndName {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          align-content: center;
          .appIcon {
            height: 46px;
            width: 46px;
            display: flex;
            align-items: center;
            justify-content: center;
            align-content: center;
            border-radius: 8px;
            .iconBox {
              width: 38px;
              height: 38px;
              display: flex;
              align-content: center;
              justify-content: center;
              align-items: center;
            }
            .iconBlueBox:hover {
              background: #00489e !important;
              border-radius: 4px !important;
            }

            .iconBlackBox:hover {
              background: black !important;
              border-radius: 4px !important;
            }
          }
          .appName {
            color: rgba(255, 255, 255, 1) !important;
            font-size: 12px !important;
            font-family: "Avenir", Helvetica, Arial, sans-serif !important;
            text-align: center !important;
            line-height: 17px !important;
            font-weight: 300;
          }
        }
      }
    }
    .pluginBox {
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: flex-start;
      // padding-top: 20px;
      align-items: center;
      .iconAndName {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        align-content: center;
        .appIcon {
          height: 46px;
          width: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          align-content: center;
          border-radius: 8px;
          .iconBox {
            width: 38px;
            height: 38px;
            display: flex;
            align-content: center;
            justify-content: center;
            align-items: center;
          }
          :hover {
            background: #00489e;
            border-radius: 4px !important;
          }
        }
        .appName {
          color: rgba(255, 255, 255, 1) !important;
          font-size: 12px !important;
          font-family: "Avenir", Helvetica, Arial, sans-serif !important;
          text-align: center !important;
          line-height: 17px !important;
          font-weight: 300;
        }
      }
    }
    .versionBox {
      border-top: 1px solid rgba(255, 255, 255, 0.29);
      position: fixed;
      bottom: 10px;
      width: 60px;
      padding-top: 8px;
      display: flex;
      justify-content: center;
      justify-content: space-evenly;
    }
  }
}

.versionDialogStyle {
  display: flex;
  flex-direction: column;
  .appVersionBox {
    width: 100%;
    .appVersionBoxItem {
      display: flex;
      flex: 1;
      margin: 20px 0;
      .appNameBox {
        width: 48.5%;
        text-align: right;
        margin-right: 5px;
      }
      .appVersionBox {
        width: 48.5%;
        text-align: left;
        margin-left: 5px;
      }
    }
  }
  .copyrightBox {
    margin: 20px 0 0 0;
    width: 100%;
    color: rgba(0, 0, 0, 0.6);
  }
}

::v-deep .dialogStyle {
  text-align: center;
  border-radius: 10px !important;
  .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #e9e9e9;
  }
  .el-dialog__body {
    text-align: left;
  }
}

.fixedTopHeader {
  position: fixed;
  left: 60px;
  top: 0px;
  width: calc(100% - 60px);
  height: 50px;
  z-index: 2000;
  background-color: white;
}
//////////////////////////license文件上传及协议相关内容/////////////////////////
::v-deep .el-upload {
  width: 100%;
}
::v-deep .el-upload-dragger {
  width: 100%;
}
.content {
  margin-top: 10px;
  line-height: 30px;
  height: 400px;
  overflow: auto;
  div {
    margin-bottom: 10px;
  }
}
.contentTitle {
  font-weight: 600;
  line-height: 35px;
}
.buttonPosition {
  text-align: right;
  margin-right: 20px;
  margin-top: 10px;
}
.privacyStyle {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #015ac5;
  font-weight: 600;
  cursor: default;
}
.privacyStylehover {
  cursor: pointer;
  white-space: nowrap;
}
/////////////////////////////////////////////////////////////////////////////

// 弹窗遮罩层背景颜色
::v-deep .el-overlay {
  background-color: rgba(0, 0, 0) !important;
}
</style>
